<template>
  <div>
    <div class="container m-pd">
      <div class="block3">
        <div class="title">{{$t('renewal_text')}}</div>
        <div class="form">
          <input
            type="tel"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57 && /^\d{0,11}$/.test(this.value));"
            :placeholder="$t('iin')"
            v-model="iin"
          />
          <div class="zb-button">
            <input
              type="tel"
              @keypress="restrictChars($event)"
              :placeholder="$t('ticket_number')"
              class="p-195"
              ref="zalog_input"
              v-model="code"
            />
            <div class="bb-span">
              <span @click="clickButton(1)">_Юи_</span>
              <span @click="clickButton(2)">_Би_</span>
              <span @click="clickButton(3)">_А_</span>
              <span @click="clickButton(4)">_Ш_</span>
            </div>
          </div>
          <button
            class="button-yellow"
            @click="getprolongationExpress"
            :class="
              this.iin != '' && this.code != '' && this.iin.length == 12
                ? 'button-yellow'
                : 'button-yellow disabled'
            "
          >
           {{$t('further')}}
          </button>
          <div class="errors">{{ errors }}</div>
        </div>
        <div class="payment">
          <div class="payment_title">
            {{$t('text_4')}}
          </div>
          <div class="payment-flex">
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-1.svg" alt="" />
              <span>{{$t('mobile_app')}}</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-2.svg" alt="" />
              <span>{{$t('telegram_bot')}}</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-3.svg" alt="" />
              <span>Kaspi.kz</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-4.svg" alt="" />
              <span>{{$t('qiwi_terminals')}}</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-5.svg" alt="" />
              <span>{{$t('kassa_24')}}</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/icon/ic-8.svg" alt="" />
              <span>HomeBank</span>
            </div>
            <div class="payment-flex_item">
              <img src="@/assets/img/bcc.png" alt="" />
              <span>ВСС Платежи</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-window-extension">
      <div id="modal-extension" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <img src="@/assets/img/icon/close.svg" alt="" />
            </button>
            <div v-if="loader" class="loader">
              <img :src="require('@/assets/img/loader.gif')" alt="" />
            </div>
            <div class="modal-body">
              <div class="title-m">{{$t('renewal_text')}}</div>
              <div class="fm-text">
                <div class="fm">
                  <span>{{$t('ticket_number_2')}}</span> <span>{{ ticket.code }}</span>
                </div>
                <div class="fm">
                  <span>{{$t('status')}}</span> <span>{{ ticket.status }}</span>
                </div>
                <div class="fm">
                  <span>{{$t('date_issue')}}</span>
                  <span>{{
                    moment(ticket.issueDate).format("DD.MM.YYYY")
                  }}</span>
                </div>
                <div class="fm">
                  <span>{{$t('maturity_date')}}</span>
                  <span>{{
                    moment(ticket.prolongDate).format("DD.MM.YYYY")
                  }}</span>
                </div>
                <div class="fm">
                  <span>{{$t('credit_amount')}}</span> <span>{{ ticket.sumKr }} тг</span>
                </div>
                <div class="fm" v-if="fee_data != ''"><span>{{$t('amount_fine')}}</span> <span>{{fee}} тг</span></div>
                <div class="fm"><span>{{$t('rollover_amount')}}</span> <span>{{per_day * days}} тг</span></div>
              </div>
              <div class="fm-graf">
                <div class="fmg">
                  <span>{{$t('parameters')}}</span>
                  <span class="small"
                    >{{$t('minimum')}} {{$t('day_d')}} {{ ticket.min_days }}</span
                  >
                </div>
                <div class="fm-border">
                  <vue-slider
                    v-model="days"
                    :min="ticket.min_days"
                    :max="max"
                    :tooltip="'always'"
                    @change="dayFunc(ticket)"
                  />
                  <div class="numbers">
                    <span>{{ ticket.min_days }}</span>
                    <span>{{ max }}</span>
                  </div>
                  <div class="border"></div>
                </div>
              </div>
              <div class="fm-calc">
                <div class="fmc">
                  <span>{{$t('days_extension')}}</span>
                  <input
                    type="number"
                    class="number"
                    pattern=" 0+\.[0-9]*[1-9][0-9]*$"
                    :min="ticket.min_days"
                    :max="max"
                    v-model="days"
                    @change="
                      defaultValue(ticket);
                      dayFunc(ticket);
                    "
                    @input="dayFunc(ticket)"
                    @keyUp="dayFunc(ticket)"
                    name="input-vue-slider"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
                <div class="fmc">
                  <span>{{$t('to_pay')}}</span>
                  <p>{{ pay }} тг</p>
                </div>
                <div class="fmc" v-if="vendorComission">
                    <span>{{ $t("vendor_comission") }}</span>
                    <span>{{ vendorComission }} тг</span>
                  </div>
              </div>
              <button class="button-yellow" @click="payProlongationExpress">
                {{$t('pay')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
  name: 'prolongationExpress',
  components: {
    VueSlider
  },
  data () {
    return {
      days: 30,
      max: 30,
      ticket: '',
      iin: '',
      code: '',
      pay: '',
      loader: true,
      errors: '',
      fee: 0,
      per_day: 0,
      pay_comission: 0
    }
  },
  computed: {
    vendorComission () {
      if (!this.pay_comission) return 0

      const comission = (this.pay * this.pay_comission) / 100
      const round = Math.round((comission + Number.EPSILON) * 100) / 100

      return round
    }
  },
  methods: {
    restrictChars: function ($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true
      } else {
        $event.preventDefault()
      }
    },
    getprolongationExpress () {
      this.$axios
        .get(
          '/user/prolongation-express?ticket-prolong=' +
            this.code +
            '&iin-prolong=' +
            this.iin
        )
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.errors = $response.message
          } else {
            this.ticket = $response.data
            this.feeTicket()
            this.checkProlong()
            $('#modal-extension').modal('show')
          }
        })
        .catch(e => console.log(e))
    },
    feeTicket () {
      this.loader = true
      this.$axios
        .get(
          `https://cabinet.seiflombard.kz/user/default/check-prolong?id=${this.ticket.id}&days=30`
        )
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.loader = false
          } else {
            this.loader = false
            this.fee_data = $response.data
            this.fee = $response.data.fee
            this.per_day = $response.data.per_day
            this.pay = this.per_day * this.days + this.fee
            this.pay_comission = $response.data.comission
          }
        })
        .catch(e => console.log(e))
    },
    checkProlong () {
      this.pay = this.per_day * this.days + this.fee
      // this.$axios
      //   .get(
      //     "https://seiflombard.kz/user/default/check-prolong-v2?id=" +
      //       this.ticket.id +
      //       "&days=" +
      //       this.days
      //   )
      //   .then(response => {
      //     let $response = response.data;
      //     if ($response.code === 0) {
      //       console.log($response);
      //     } else {
      //       this.pay = $response.data.summa;
      //     }
      //   })
      //   .catch(e => console.log(e));
    },
    dayFunc (ticket) {
      if (this.days > this.max) {
        this.days = this.max
      }
      if (this.days >= ticket.min_days) {
        this.checkProlong()
        var tempTicket = this.ticket
        this.ticket = []
        this.ticket = tempTicket
      }
    },
    defaultValue (ticket) {
      if (this.days.length == 0) {
        this.days = ticket.min_days
      }
      if (this.days < ticket.min_days) {
        this.days = ticket.min_days
      }
      if (this.days > this.max) {
        this.days = this.max
      }
    },
    payProlongationExpress () {
      window.open(
        'https://cabinet.seiflombard.kz/pay/pay-prolong?id=' +
          this.ticket.id +
          '&days=' +
          this.days +
          '&bonus=0'
      )
      $('#modal-extension').modal('hide')
    },

    clickButton (index) {
      if (index == 1) {
        this.code = this.code + '_Юи_'
      }
      if (index == 2) {
        this.code = this.code + '_Би_'
      }
      if (index == 3) {
        this.code = this.code + '_А_'
      }
      if (index == 4) {
        this.code = this.code + '_Ш_'
      }
      this.$refs.zalog_input.focus()
    }
  },
  mounted () {
    var obj = this
    $('#modal-extension').on('hidden.bs.modal', function () {
      obj.days = 30
      obj.max = 30
      obj.ticket = ''
      obj.iin = ''
      obj.code = ''
      obj.pay = ''
      obj.loader = false
    })
  }
}
</script>
<style scoped>
.errors {
  position: absolute;
  left: 0;
  right: 0;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/prolongationExpress.vue